import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import imageIcon from '../theme/image-browser.svg';

/**
 * The image insert from browser.
 *
 * Adds the `'imageBrowser'` button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}.
 *
 * @extends module:core/plugin~Plugin
 */
export default class ImageBrowserUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;		

		// Setup `imageBrowser` button.
		editor.ui.componentFactory.add( 'imageBrowser', locale => {
			const view = new ButtonView( locale );
			
			const command = editor.commands.get( 'imageInsert' );
			view.bind( 'isEnabled' ).to( command );

			view.set( {
				label: t( 'Insert image from browser' ),
				icon: imageIcon,
				tooltip: true
			} );

			view.on( 'execute', () => {
                Browser.getInstance().open(null, function(asset){
				    editor.execute('imageInsert', {source: asset.file});
				});
            });

			return view;
		} );
	}
}
